import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { App } from '@df/core/app';
import { Meta } from '@df/core/meta/meta';
import { Client } from '@df/core/service/client';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { ICmsPage } from '@icms/core/resource/page/icms-page';

declare global {
    interface Window {
        HubSpotConversations?: {
            widget?: {
                open: () => void;
                close: () => void;
                remove: () => void;
                refresh: () => void;
            };
        };
    }
}
@Injectable()
export class HubspotService {
    private isVisible = true;
    private renderer2: Renderer2;

    constructor(
        private requestService: RequestService,
        private meta: Meta,
        private client: Client,
        private app: App,
        private rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) protected document: Document,
        private pwaIntegrationService: PwaIntegrationService
    ) {
        this.renderer2 = rendererFactory.createRenderer(null, null);
    }

    async load(): Promise<void> {
        if (!this.app.isPlatformBrowser) {
            return;
        }
        await this.loadScript();
        this.update();
        this.meta.subject.subscribe(() => this.update());
        this.client.isCms$.subscribe(() => this.update());
    }

    private update(): void {
        const shouldBeVisible = this.shouldBeVisible;
        if (this.isVisible !== shouldBeVisible) {
            if (shouldBeVisible) {
                if (!this.isVisible) {
                    this.renderer2.removeClass(this.document.body, 'hubspotHide');
                    window.HubSpotConversations?.widget?.refresh();
                }
            } else {
                // hide class cause HubSpotConversations is sometimes undefined on refresh
                this.renderer2.addClass(this.document.body, 'hubspotHide');
                window.HubSpotConversations?.widget?.remove();
            }
            this.isVisible = shouldBeVisible;
        }
    }

    private get shouldBeVisible(): boolean {
        if (this.client.isCms || this.client.isBot || this.app.acl.isDeveloper || this.pwaIntegrationService.isStandalone) {
            return false;
        }
        const model = this.meta.model as ICmsPage<IPageDataV3>;
        if (!model || (model?.type === 'page' && model.data?.additional?.hideHubspot)) {
            return false;
        }
        return true;
    }

    private loadScript(): Promise<HTMLScriptElement> {
        return this.requestService.loadScriptAsync(`https://js-eu1.hs-scripts.com/143489889.js`, {
            onScript: script => {
                script.id = 'hs-script-loader';
            }
        });
    }
}
